import React from 'react'

import {
  Attachment as AttachmentIcon,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as EmptyCheckBoxIcon,
  Comment as CommentIcon,
  Image as ImageIcon,
} from '@mui/icons-material'

import { formatHarvest } from '~/src/Annotations/Formatters/Harvest'
import { formatLightSchedule } from '~/src/Annotations/Formatters/LightSchedule'
import { formatNote } from '~/src/Annotations/Formatters/Note'
import { formatNotification } from '~/src/Annotations/Formatters/Notification/utils'
import { formatPesticideApplication } from '~/src/Annotations/Formatters/PesticideApplication'
import { formatReading } from '~/src/Annotations/Formatters/Reading'
import { formatTargetRange } from '~/src/Annotations/Formatters/TargetRange'
import { formatTask } from '~/src/Annotations/Formatters/Task'
import { defer, getDateTime } from '~/src/Lib/Utils'
import BatchIcon from '~/src/UI/Icons/Batch'
import LightsOnIcon from '~/src/UI/Icons/LightsOn'
import Measurement from '~/src/UI/Icons/Measurement'
import SprayIcon from '~/src/UI/Icons/Spray'
import TargetRangeIcon from '~/src/UI/Icons/TargetRange'

import {
  HarvestFormatter,
  LightScheduleFormatter,
  NoteFormatter,
  NotificationFormatter,
  NotificationIconFormatter,
  PesticideApplicationFormatter,
  ReadingFormatter,
  TargetRangeFormatter,
  TaskFormatter,
} from '../Formatters'

/* eslint-disable babel/camelcase */
export default {
  notes: {
    icons: {
      default: CommentIcon,
      photo: ImageIcon,
      attachment: AttachmentIcon,
      substrate: {
        getIcon: () => <BatchIcon />
      },
    },
    tooltip: NoteFormatter,
    formatData: formatNote,
  },
  tasks: {
    icons: {
      check_box: CheckBoxIcon,
      check_box_outline_blank: EmptyCheckBoxIcon,
    },
    tooltip: TaskFormatter,
    formatData: formatTask,
  },
  notifications: {
    icon: { getIcon: NotificationIconFormatter },
    tooltip: NotificationFormatter,
    onClose: ({ annotation, setActiveNotification }) => {
      if (!setActiveNotification) return
      defer(
        () => setActiveNotification(active => (
          active === annotation ? null : active
        )),
        defer.priorities.low
      )
    },
    onOpen: ({ annotation, setActiveNotification }) => {
      if (!setActiveNotification) return
      setActiveNotification(active => (
        active !== annotation ? annotation : active
      ))
    },
    formatData: formatNotification,
  },
  pesticideApplications: {
    icon: SprayIcon,
    tooltip: PesticideApplicationFormatter,
    formatData: formatPesticideApplication,
  },
  readings: {
    icon: Measurement,
    tooltip: ReadingFormatter,
    formatData: formatReading,
  },
  harvests: {
    icons: {
      batch: {
        getIcon: props => {
          const { annotation, timestamp } = props // eslint-disable-line react/prop-types
          if (
            getDateTime(timestamp).hasSame(
              getDateTime(annotation.harvestDate), // eslint-disable-line react/prop-types
              'day'
            )
          ) {
            return <BatchIcon faded />
          }
          return <BatchIcon />
        },
      },
    },
    tooltip: HarvestFormatter,
    formatData: formatHarvest,
  },
  harvestPhases: {
    icons: {
      batch: {
        getIcon: props => {
          const { annotation, timestamp } = props // eslint-disable-line react/prop-types
          if (
            getDateTime(timestamp).hasSame(
              getDateTime(annotation.harvestDate), // eslint-disable-line react/prop-types
              'day'
            )
          ) {
            return <BatchIcon faded />
          }
          return <BatchIcon />
        },
      },
    },
    tooltip: HarvestFormatter,
    formatData: formatHarvest,
  },
  targetRanges: {
    icon: TargetRangeIcon,
    tooltip: TargetRangeFormatter,
    formatData: formatTargetRange,
  },
  lightSchedules: {
    icon: LightsOnIcon,
    tooltip: LightScheduleFormatter,
    formatData: formatLightSchedule,
  },
}
/* eslint-enable babel/camelcase */
